import React, { Component } from 'react'
import moment from 'moment'
import { Select, notification, Tabs } from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import { __ } from '@wordpress/i18n'

import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'

const VC_CONFIG = _.get(window, 'VC_CONFIG', {})
const Local = _.get(window, 'VC_CONFIG.Locale')
const isLogin = _.get(this, 'props.auth.isLogin')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
// 前端頁面
export default class MemberCobrandedcard extends Component {
  formRef = React.createRef()
  state = {
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    tableData: [],
    tableData_Detail: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
  }

  // ALVIN 2023/05/05 調整為CC登入
  GetCCUri = () => {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/cc/login`, {}, (state, res) => {
      console.log(state, res)

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        this.setState({ isSubmitData: false })
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        this.setState({ isSubmitData: false })
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)

      // 改為前往CC登入頁面
      // this.GoCCLoginPage(data.uri)
      this.setState({ isSubmitData: false })
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  // 2023/05/05 取得並前往 CC Login Url
  GoCCLoginPage = (ccApiUrl) => {
    whttp.get(ccApiUrl, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res
      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }
      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }

  GetOcaUri = () => {
    this.setState({ isSubmitData: true })
    whttp.get(API_HOST + `/api/account/oca/login`, {}, (state, res) => {
      console.log(state, res)
      this.setState({ isSubmitData: false })

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res

      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
      }

      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL
          },
        })
        return
      }
      console.log(code, reason, data, res)
      this.setState({ LoginUrl: data.uri })
      window.location.href = data.uri
    })
  }
  componentDidMount() {
    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    const query = {
      start_dt: moment(firstDay).format('YYYY-MM-DD'),
      end_dt: moment(lastDay).format('YYYY-MM-DD'),
    }
    // AppHelper.updateConfig()
    this.setState({ query })
    this.control()
    // var swiper = new Swiper('.swiper-memberCard', {
    //   spaceBetween: 10,
    //   loop: true,
    //   slidesPerView: 'auto',
    //   centeredSlides: true,
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   pagination: { el: '.swiper-pagination' },
    //   breakpoints: { 767: { spaceBetween: 0 } },
    // });
  }
  control = () => {
    $(document).ready(function() {
      $(document).on(
        'show.bs.collapse',
        '.tbody .order-detail-info',
        function() {
          $('.order-detail-info').removeClass('show')
          //$(this).addClass('show');
        }
      )
    })
  }
  clickgetdetail = (ID = '') => {
    console.log('555555555555555555', ID)
    this.setState({ isLoading: true })
    whttp.post(
      API_HOST + '/api/account/purchaseDetail',
      {
        pur_id: ID,
      },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return this.setState({ message: '發生錯誤' })
        }

        if (code !== 200) {
          return this.setState({ message: reason })
        }
        this.setState(
          { tableData_Detail: data.purchaseDetail, isLoading: false },
          () => {
            this.refreshPicker()
          }
        )
      }
    )
  }

  fillData = (data = {}) => {
    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isNil(data.address) || !_.isObject(data.address)) {
      data.address = {
        city_id: _.get(data, 'city_id'),
        area_id: _.get(data, 'area_id'),
      }
    }

    console.log('filldata', data)
    this.formRef.current.setFieldsValue(data)
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)
  render() {
    const isLogin = this.props.auth.isLogin
    let $query
    if (isLogin) {
      $query = (
        <a
          className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
          role='button'
          href={`${VC_CONFIG.INDEX_URL}/payment`}>
          立即查詢
        </a>
      )
    } else {
      $query = (
        <a
          className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
          role='button'
          href='#'
          onClick={() => {
            // ALVIN 2023/05/05 調整為CC Login
            // this.GetOcaUri();
            this.GetCCUri()
          }}>
          立即查詢
        </a>
      )
    }
    return (
      <div>
        <p />
        <p />
        <main className='bg-light'>
          <div class='container'>
            <div class='breadcrumb-wrap py-4 m-0'>
              <nav aria-label='breadcrumb'>
                <ol class='breadcrumb'>
                  <li class='breadcrumb-item'>
                    <a href='[index]'>首頁</a>
                  </li>
                  <li class='breadcrumb-item'>
                    <a href='#'>會員權益</a>
                  </li>
                  <li class='breadcrumb-item active' aria-current='page'>
                    關於聯名卡
                  </li>
                </ol>
              </nav>
            </div>
            <section class='py-3'>
              <h4 class='heading-title justify-content-center'>
                卡友優惠說明
              </h4>
            </section>
          </div>
          <div class='basic-tabs-label mb-5'>
            <ul id='pills-tab' class='nav nav-pills'>
              <li class='nav-item'>
                <a class='nav-link' href='[index]/member-hkcard'>
                  關於好康卡
                </a>
              </li>
              <li class='nav-item'>
                <a class='nav-link' href='[index]/member-vip'>
                  關於 VIP
                </a>
              </li>
              <li class='nav-item current_page_item highlight'>
                <a class='nav-link' href='[index]/member-cobrandedcard'>
                  關於聯名卡
                </a>
              </li>
            </ul>
          </div>
          <div className='container'>
            <section>
              <div className='row align-items-center justify-content-center'>
                <div className='col-md-6 col-lg-5 mx-auto'>
                  <div className='swiper-container swiper-memberCard'>
                    <div className='swiper-wrapper'>
                      <div className='swiper-slide'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/card.png`}
                          alt=''
                        />
                      </div>
                      <div className='swiper-slide'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/card2.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='swiper-pagination' />
                  </div>
                </div>
                <div className='col-lg-5 my-lg-0 my-5'>
                  <div className='text-center'>
                    <h4 className='h4 title-theme-1 text-navy mb-4'>
                      玉山悠遊聯名卡
                    </h4>
                    <h5 className='h6 text-danger my-5'>
                      天天都優惠 好康多更多
                      <br />
                      年年有消費 年年免年費
                      <br />
                      悠遊卡/icash卡超方便 感應刷卡免簽名
                    </h5>
                    <p className='note text-navy mb-0'>立即線上申辦</p>
                    <div className='row justify-content-center mt-3'>
                      <div className='col-8 col-md-5'>
                        <a
                          className='h6 mb-0 btn btn-lg btn-block btn-outline-primary rounded-pill mb-md-0 mb-3'
                          role='button'
                          href='https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0024&amp;param=APYCRD0024,,,,F000000000,,HO,,,,e#b'
                          target='_blank'
                          rel='noopener noreferrer'>
                          悠遊聯名卡
                        </a>
                      </div>
                      <div className='col-8 col-md-5'>
                        <a
                          className='h6 mb-0 btn btn-lg btn-block btn-outline-primary rounded-pill mb-md-0 mb-3'
                          role='button'
                          href='https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0041&amp;param=APYCRD0041,,,,F000000000,,HO,,,,e#b'
                          target='_blank'
                          rel='noopener noreferrer'>
                          icash聯名卡
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className='pb-0'>
              <div className='text-center'>
                <h4 className='heading-title align-items-center'>
                  消費皆可累積「點數」紅利無限大
                </h4>
                <hr className='border-top border-gray mt-0 mb-4' />
                <p className='h6 text-font'>
                  持聯名卡於店內消費：一元現換2點紅利點數，店外消費：一元現換1點紅利點數，輕鬆累積～
                  <br />
                  使用CarrfourPay
                  綁定玉山聯名卡支付，在賣場內消費，一元現換3點紅利點數，三倍好康送給您！
                </p>
                <p
                  className='h6 text-font'
                  style={{ color: 'red !important' }}>
                  ※上述積點活動需刷玉山悠遊聯名卡，詳細活動內容請見店內公告；回饋點數小數點以下不列入累計，無玉山銀行紅利點數
                </p>
              </div>
              <div className='row align-items-center justify-content-center'>
                <div className='col-lg-6 my-5'>
                  <div className='row justify-content-center'>
                    <div className='col-auto col-lg-5'>
                      <div className='whiteSky-block'>
                        <h5 className='h4 text-primary mb-4'>店內消費</h5>
                        <h6 className='h4 text-center text-navy m-0 fw-700'>
                          <strong className='fw-700 px-1 text-danger'>
                            1
                          </strong>
                          元
                          <strong className='fw-700 px-1 text-danger'>
                            2
                          </strong>
                          點
                        </h6>
                        <p className='note text-font mt-4 mb-0'>
                          約0.66%現金回饋
                        </p>
                      </div>
                    </div>
                    <div className='col-auto col-lg-5'>
                      <div className='whiteSky-block'>
                        <h5 className='h4 text-primary mb-4'>店外消費</h5>
                        <h6 className='h4 text-center text-navy m-0 fw-700'>
                          <strong className='fw-700 px-1 text-danger'>
                            1
                          </strong>
                          元
                          <strong className='fw-700 px-1 text-danger'>
                            1
                          </strong>
                          點
                        </h6>
                        <p className='note text-font mt-4 mb-0'>
                          約0.33%現金回饋
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className='pt-0'>
              <div className='row no-gutters mx-n2'>
                <div className='col-sm-6 col-md-4 col-lg px-2 my-3'>
                  <div className='row align-items-start my-5 no-gutters mx-n2'>
                    <div className='col-3 col-md-4 mx-auto px-2'>
                      <div className='px-3'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/icon01.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='col-9 col-md-8 px-2'>
                      <h5 className='h5 text-navy mb-3 fw-700'>
                        點數變現金
                        <br />
                        購物省最多
                      </h5>
                      <p className='p fw-300 text-dark mb-4'>
                        300點點數可扣抵1元，特選目錄/店內商品，可享額外點數/會員價
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-sm-6 col-md-4 col-lg px-2 my-3'>
                  <div className='row align-items-start my-5 no-gutters mx-n2'>
                    <div className='col-3 col-md-4 mx-auto px-2'>
                      <div className='px-3'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/icon02.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='col-9 col-md-8 px-2'>
                      <h5 className='h5 text-navy mb-3 fw-700'>
                        卡友獨享
                        <br />
                        分期0利率
                      </h5>
                      <p className='p fw-300 text-dark mb-4'>
                        全國賣場內消費滿額享3~12期分期付款0利率，特定商品可享24或30期分期付款0利率
                      </p>
                      <p
                        className='p fw-300 text-dark mb-4'
                        style={{ color: 'red !important' }}>
                        ※店內分期消費仍可累積紅利點數
                        <br />
                        ※活動詳情及注意事項請洽全國門市
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-sm-6 col-md-4 col-lg px-2 my-3'>
                  <div className='row align-items-start my-5 no-gutters mx-n2'>
                    <div className='col-3 col-md-4 mx-auto px-2'>
                      <div className='px-3'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/icon03.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='col-9 col-md-8 px-2'>
                      <h5 className='h5 text-navy mb-3 fw-700'>
                        eTag自動儲值
                        <br />
                        國道通行真順暢
                      </h5>
                      <p className='p fw-300 text-dark mb-4'>
                        連結eTag預儲帳戶，餘額低於120元自動儲值400元(
                        或其倍數 )免手續費、免煩惱、國道通行一路順暢
                      </p>
                    </div>
                  </div>
                </div>
                <div className='col-sm-6 col-md-4 col-lg px-2 my-3'>
                  <div className='row align-items-start my-5 no-gutters mx-n2'>
                    <div className='col-3 col-md-4 mx-auto px-2'>
                      <div className='px-3'>
                        <img
                          className='img-contain'
                          src={`${
                            VC_CONFIG.INDEX_URL
                          }/wp-content/themes/cec/assets/img/membercard/coBrand/icon04.png`}
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='col-9 col-md-8 px-2'>
                      <h5 className='h5 text-navy mb-3 fw-700'>
                        悠遊卡超方便
                        <br />
                        感應刷卡免簽名
                      </h5>
                      <p className='p fw-300 text-dark mb-4'>
                        超過萬家悠遊卡小額支付特店，免帶零錢輕鬆付款感應式交易，免刷卡、免簽名、便利又快速
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className='pt-0'>
              <h4 className='heading-title align-items-center'>
                玉山悠遊Debit卡
              </h4>
              <hr className='border-top border-gray mt-0 mb-4' />
              <div className='row align-items-center justify-content-center'>
                <div className='col-lg-6'>
                  <div className='row'>
                    <div className='col-md-6 col-lg-10 mx-auto'>
                      <img
                        className='img-fluid'
                        src={`${
                          VC_CONFIG.INDEX_URL
                        }/wp-content/themes/cec/assets/img/membercard/card-coBrand2.png`}
                        alt=''
                      />
                    </div>
                  </div>
                </div>
                <div className='col-lg-5 my-lg-0 my-5'>
                  <div className='text-center'>
                    <h4 className='h4 title-theme-1 text-navy mb-4'>
                      一張幫我賺錢的卡
                    </h4>
                    <h5 className='h6 text-primary mb-4'>
                      1.簽帳消費：國內外都能刷、更有效管理帳戶
                      <br />
                      2.金融卡提款、存款與轉帳：提款、轉帳真便利
                    </h5>
                    <p className='note text-dark mb-3'>
                      首刷單筆滿額贈「紅利點數3萬點」
                      <br />
                      （首次申辦玉山悠遊Debit卡，且留email，核卡後45天內於店內，單筆刷滿599元(含)以上，贈「紅利點數3萬點」。
                    </p>
                  </div>
                  <div className='row'>
                    <div className='col-sm-6 mx-auto my-3'>
                      <a
                        className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                        role='button'
                        href='https://www.esunbank.com.tw/bank/personal/credit-card/intro/debit-card/c4-debit-card'
                        target='_blank'
                        rel='noopener noreferrer'>
                        最新Debit卡優惠活動
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <h4 className='heading-title justify-content-center'>
              玉山聯名卡 / Debit卡卡友優惠
            </h4>
            <hr className='border-top border-gray mt-0 mb-5' />
            <div className='embed-responsive embed-responsive-16by9 mb-5'>
              <iframe
                className='embed-responsive-item'
                title='embed-responsive-item'
                src='https://www.youtube.com/embed/6tbR9uhR35U'
                frameborder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowfullscreen=''
              />
            </div>
            <div className='row align-items-center'>
              <div className='col-lg-12 mb-5'>
                <img
                  className='img-contain'
                  src='https://testwww.uni-prosperity.com.tw/wp-content/uploads/2020/11/2020DM3_卡友說明1401any-4.jpg'
                  alt=''
                />
                <button
                  style={{
                    backgroundColor: 'transparent',
                    width: '12%',
                    height: '2%',
                    position: 'absolute',
                    right: '8.5%',
                    bottom: '31%',
                    border: 'none',
                    outline: 'none',
                    cursor: 'pointer',
                  }}
                />
              </div>
            </div>
            <div className='row my-3 justify-content-center'>
              <div className='col-md-12'>
                <h6 className='h5 text-navy text-center mb-4'>
                  最新優惠活動
                </h6>
              </div>
              <div className='col-sm-3'>
                <a
                  className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                  role='button'
                  href='https://www.esunbank.com.tw/bank/personal/credit-card/intro/co-branded-card/c4-card'
                  target='_blank'
                  rel='noopener noreferrer'>
                  最新悠遊聯名卡優惠活動
                </a>
              </div>
              <div className='col-sm-3'>
                <a
                  className='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                  role='button'
                  href='https://www.esunbank.com.tw/bank/personal/credit-card/intro/co-branded-card/c4-icash-card'
                  target='_blank'
                  rel='noopener noreferrer'>
                  最新icash聯名卡優惠活動
                </a>
              </div>
            </div>
            <section>
              <h4 className='heading-title align-items-center'>
                申辦聯名卡會員
              </h4>
              <hr className='border-top border-gray mt-0 mb-5' />
              <div className='row justify-content-center mb-5'>
                <div className='col-lg-8'>
                  <div className='memberCard-step-wrap'>
                    <div className='memberCard-step-item'>
                      <div className='info'>
                        <h6 className='h6 text-primary text-center mb-4'>
                          立即線上申辦
                        </h6>
                        <div className='px-md-5 px-3'>
                          <div className='row justify-content-center mb-4'>
                            <div className='col-md-5'>
                              <a
                                className='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3'
                                role='button'
                                href='https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0024&amp;param=APYCRD0024,,,,F000000000,,HO,,,,e#b'
                                target='_blank'
                                rel='noopener noreferrer'>
                                玉山悠遊聯名卡
                              </a>
                            </div>
                            <div className='col-md-5'>
                              <a
                                className='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill mb-md-0 mb-3'
                                role='button'
                                href='https://card.esunbank.com.tw/EsunCreditweb/txnservice/identify?PRJCD=APYCRD0041&amp;param=APYCRD0041,,,,F000000000,,HO,,,,e#b'
                                target='_blank'
                                rel='noopener noreferrer'>
                                玉山icash聯名卡
                              </a>
                            </div>
                          </div>
                          <p className='h6 text-navy text-center mb-0'>
                            提醒您：點選後將進入玉山銀行信用卡網站
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className='memberCard-step-item'>
                      <div className='info'>
                        <h6 className='h6 text-primary text-center mb-4'>
                          分店臨櫃申辦
                        </h6>
                        <div className='px-md-5 px-3'>
                          <p className='h6 text-navy mb-4'>
                            攜帶個人證件、財力證明與表格至鄰近的
                            <br />
                            *財力證明：薪資單(最近3個月影本)、存摺(帳號戶名封面及近三個月內頁明細)等。
                            <br />
                            *玉山銀行保留聯名卡申請核准與否之權利。
                          </p>
                          <p className='h6 text-navy mb-4'>
                            送件後，資料齊全約二至三週即會寄送聯名卡至登記地址
                            <br />
                            *店內申辦馬上領取好康卡，讓您在聯名卡審核期間，不錯失集點機會！馬上積點，點數變現金！
                          </p>
                          <p>
                            <a
                              className='h6 mb-0 btn btn-lg btn-block btn-outline-navy rounded-pill'
                              role='button'
                              href={`${VC_CONFIG.INDEX_URL}/stores`}>
                              查詢分店位置
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card card-storeInfo shadow-0 card-border-width-1 rounded-20 h-100'>
                <div className='card-body'>
                  <div className='row align-items-center justify-content-center'>
                    <div className='col-8 col-md-3 mx-md-0 mx-auto'>
                      <img
                        className='img-contain'
                        src={`${
                          VC_CONFIG.INDEX_URL
                        }/wp-content/themes/cec/assets/img/membercard/credit_card2.svg`}
                        alt=''
                      />
                    </div>
                    <div className='col-md-auto'>
                      <div className='text-center'>
                        <h5 className='h4 text-navy my-4 fw-700'>
                          查詢會員卡點數
                        </h5>
                        <p className='p text-font mb-5'>
                          已經是會員了嗎？ 立即綁定卡片，查詢點數好輕鬆！
                        </p>
                        <div className='row'>
                          <div className='col-md-9 col-6 mx-auto'>
                            {$query}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <p />
        </main>
        <p />

        <p />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/member/member-cobrandedcard.js